(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["easy-diesel-quick-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ed-quick-order')) {
  customElements.define('ed-quick-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.busy = false;
      this.locked = false;
      this.rows = [...this.querySelectorAll('.ed-quick-row')];
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.cartLink = this.querySelector('[data-cart]');
      this.reorderLink = this.querySelector('[data-reorder-link]');
      this.copyButton = this.querySelector('[data-copy-link]');
      this.linkStatus = this.querySelector('[data-link-status]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style: 'currency', currency: this.dataset.currency || 'USD'});
      this.addEventListener('input', () => { this.linkStatus.textContent = ''; this.update(); });
      this.button.addEventListener('click', () => this.addItems());
      this.copyButton.addEventListener('click', () => this.copyLink());
      this.restoreLink();
      this.update();
    }
    restoreLink() {
      const params = new URL(window.location.href).searchParams.getAll('ed_mix');
      if (!params.length) return;
      const quantities = new Map();
      const encoded = params[0];
      let valid = params.length === 1 && encoded.length > 0 && encoded.length <= 240;
      const entries = encoded.split(',');
      if (entries.length > 4) valid = false;
      for (const entry of entries) {
        const match = /^(ED-[A-Z0-9-]+):(0|[1-9][0-9]{0,15})$/.exec(entry);
        if (!match) { valid = false; break; }
        const sku = match[1];
        const quantity = Number(match[2]);
        if (!Number.isSafeInteger(quantity) || !this.rows.some(row => row.dataset.sku === sku) || quantities.has(sku)) { valid = false; break; }
        quantities.set(sku, quantity);
      }
      if (!valid) { this.linkStatus.textContent = this.dataset.linkInvalid; return; }
      for (const row of this.rows) row.querySelector('input').value = String(quantities.get(row.dataset.sku) || 0);
      this.linkStatus.textContent = this.dataset.linkLoaded;
    }
    shareUrl(choice) {
      if (choice.invalid || !choice.units) return '';
      const parts = choice.items.map(item => {
        const row = this.rows.find(row => Number(row.dataset.id) === item.id);
        return `${row.dataset.sku}:${item.quantity}`;
      });
      const url = new URL(this.dataset.reorderUrl, window.location.origin);
      url.search = '';
      url.hash = 'quick-order';
      url.searchParams.set('ed_mix', parts.join(','));
      return url.href;
    }
    async copyLink() {
      const value = this.reorderLink.value;
      if (!value || this.copyButton.disabled) return;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(value);
        this.linkStatus.textContent = this.dataset.linkCopied;
      } catch (_) {
        this.reorderLink.focus();
        this.reorderLink.select();
        this.linkStatus.textContent = this.dataset.linkCopyManual;
      }
    }
    selection() {
      const items = [];
      let units = 0;
      let cents = 0;
      let invalid = false;
      let unavailable = false;
      for (const row of this.rows) {
        const input = row.querySelector('input');
        const quantity = input.value === '' ? 0 : Number(input.value);
        const min = Number(row.dataset.min) || 1;
        const increment = Number(row.dataset.increment) || 1;
        const price = Number(row.dataset.price);
        const bad = !Number.isSafeInteger(quantity) || quantity < 0 || (quantity > 0 && (quantity < min || (quantity - min) % increment !== 0)) || !Number.isSafeInteger(price) || price < 0;
        input.setAttribute('aria-invalid', String(bad));
        if (bad) { invalid = true; continue; }
        if (!quantity) continue;
        if (row.dataset.available !== 'true' || (row.dataset.stock !== '' && quantity > Number(row.dataset.stock)) || (row.dataset.max !== '' && quantity > Number(row.dataset.max))) unavailable = true;
        const id = Number(row.dataset.id);
        if (!Number.isSafeInteger(id) || id <= 0) { invalid = true; continue; }
        items.push({id, quantity});
        units += quantity;
        cents += quantity * price;
      }
      if (!Number.isSafeInteger(cents) || !Number.isSafeInteger(units)) invalid = true;
      return {items, units, cents, invalid, unavailable};
    }
    update() {
      const choice = this.selection();
      this.querySelector('[data-units]').textContent = choice.invalid ? '—' : String(choice.units);
      this.querySelector('[data-total]').textContent = choice.invalid ? '—' : this.money.format(choice.cents / 100);
      this.button.disabled = this.busy || this.locked || choice.invalid || choice.unavailable || !choice.units;
      if (!this.busy && !this.locked) this.status.textContent = choice.invalid ? this.dataset.invalid : !choice.units ? this.dataset.empty : choice.unavailable ? this.dataset.unavailable : this.dataset.ready;
      const summary = choice.invalid ? '' : choice.items.map(item => {
        const row = this.rows.find(row => Number(row.dataset.id) === item.id);
        return `${row.dataset.sku}: ${item.quantity}`;
      }).join('; ');
      this.querySelector('[data-request-mix]').value = summary ? `${summary}. Displayed retail subtotal: ${this.money.format(choice.cents / 100)}. Nonbinding estimate.` : '';
      this.reorderLink.value = this.shareUrl(choice);
      this.copyButton.disabled = !this.reorderLink.value;
      return choice;
    }
    async addItems() {
      const choice = this.update();
      if (this.button.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.status.textContent = this.dataset.adding;
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items:choice.items})});
        confirmed = response.ok;
      } catch (_) {
        confirmed = false;
      }
      this.busy = false;
      this.locked = true;
      this.button.disabled = true;
      this.cartLink.hidden = false;
      this.status.textContent = confirmed ? this.dataset.added : this.dataset.error;
      this.cartLink.focus();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
